module.exports = __webpack_public_path__ + "img/vertical_6_2_6005.5babb738.png";